// extracted by mini-css-extract-plugin
export default {"previewSection":"ReactCropper_previewSection__ZfTZm","cropperSection":"ReactCropper_cropperSection__0vzyR"};